import React from 'react';
import { connect } from 'react-redux';
import { SettingOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { UserMenu } from './components';
import { Logout } from './components/UserMenu/components';
import './RightContent.less';
import '~/layouts/components/HelpMenu/HelpMenu.less';
import { MenuService } from '~/services';

const RightContent = React.memo(({ className, settings, general }) => {
  return (
    <div
      className={classNames(className, 'right-content', {
        'right-content-dark': settings.theme === 'dark' && settings.layout === 'topmenu' && !general.isMobile,
      })}
    >
      <UserMenu className="right-content-action" />
      {/*
      <SyncIcon className="right-content-action" />
      <Settings className="right-content-action" />
      */}
      <SettingOutlined className="abrir-info" title="Alterar Senha" onClick={() => MenuService.open(MenuService.getById('6'))} />
      <Logout className="right-content-action" />
    </div>
  );
});

const mapStateToProps = ({ settings, general, remember }) => ({ settings, general, remember });

export default connect(mapStateToProps)(RightContent);
